import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./components/AuthProvider";
import { ChatPage } from "./pages/ChatPage";
import { ConfirmEmailPage } from "./pages/ConfirmEmailPage";
import { CreateWorkspacePage } from "./pages/CreateWorkspacePage";
import { ForgotPasswordPage } from "./pages/ForgotPasswordPage";
import { LoginPage } from "./pages/LoginPage";
import { MembersPage } from "./pages/MembersPage";
import { OnboardingPage } from "./pages/OnboardingPage";
import { ReportPage } from "./pages/ReportPage";
import { ResetPasswordPage } from "./pages/ResetPasswordPage";
import { SignUpPage } from "./pages/SignUpPage";

const DashboardPage = lazy(() =>
  import("./features/dashboards/DashboardPage").then((module) => ({
    default: module.DashboardPage,
  })),
);

export function AppRouter() {
  return (
    <AuthProvider>
      <Routes>
        {/* Anonymous-allowed (allowlist mirrored in AuthProvider). */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignUpPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/confirm-email" element={<ConfirmEmailPage />} />

        {/* Authenticated-only. */}
        <Route path="/create-workspace" element={<CreateWorkspacePage />} />
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route path="/chat" element={<ChatPage />} />
        <Route path="/chat/:sessionId" element={<ChatPage />} />
        <Route
          path="/dashboards"
          element={
            <Suspense fallback={<div className="full-screen-loader">Loading…</div>}>
              <DashboardPage />
            </Suspense>
          }
        />
        <Route
          path="/dashboards/:slug"
          element={
            <Suspense fallback={<div className="full-screen-loader">Loading…</div>}>
              <DashboardPage />
            </Suspense>
          }
        />
        <Route path="/report/:reportId" element={<ReportPage />} />
        <Route path="/settings/members" element={<MembersPage />} />
        <Route path="*" element={<Navigate to="/chat" replace />} />
      </Routes>
    </AuthProvider>
  );
}
